export const ukUniversities = [
  {
    name: "London Metropolitan University",
    location: "London, England, UK",
    tuition: 16500,  // Updated from 14000
    livingCost: 15000,
    description: "A diverse and career-focused university in the heart of London, known for its strong emphasis on employability.",
    ranking: "801-1000 (QS)",
    type: "Public",
    images: ["Images/UK/London Metropolitan University/campus.jpg"],
    programs: ["Business", "Art & Design", "Computing", "Social Sciences"],
    features: ["Central London Location", "Industry Links", "Modern Facilities", "Career Support"]
  },
  {
    name: "London South Bank University",
    location: "Southwark, London, UK",
    tuition: 17000,  // Updated from 15500
    livingCost: 15000,
    description: "A progressive university with a practical focus, located in the heart of London.",
    ranking: "801-1000 (THE)",
    type: "Public",
    images: ["Images/UK/London South Bank University/campus.jpg"],
    programs: ["Engineering", "Health Sciences", "Business", "Architecture"],
    features: ["Industry Partnerships", "Practical Learning", "Modern Campus", "Strong Employment Rates"]
  },
  {
    name: "Brunel University London",
    location: "Uxbridge, West London, UK",
    tuition: 19850,  // Updated from 18500
    livingCost: 14000,
    description: "Renowned for research-intensive programs and excellent sports facilities, with strong industry connections.",
    ranking: "351-400 (THE)",
    type: "Public",
    images: ["Images/UK/Brunel University London/campus.jpg"],
    programs: ["Mechanical Engineering", "Design", "Business Management", "Sports Science"],
    features: ["Single-campus University", "Olympic-standard Sports Facilities", "Industry Placement Year", "Research Excellence"]
  },
  {
    name: "University of Westminster",
    location: "London, England, UK",
    tuition: 17500,  // Updated from 15000
    livingCost: 16000,
    description: "Internationally diverse university with prime central London locations and media/communications strengths.",
    ranking: "601-800 (QS)",
    type: "Public",
    images: ["Images/UK/University of Westminster/campus.jpg"],
    programs: ["Media & Communications", "Architecture", "Fashion", "Politics"],
    features: ["Central London Campuses", "Media Industry Partnerships", "Diverse Student Body", "Creative Industries Focus"]
  },
  {
    name: "University of Wolverhampton",
    location: "Wolverhampton, West Midlands, UK",
    tuition: 15200,  // Updated from 13950
    livingCost: 10000,
    description: "Modern university with strong vocational focus and excellent student support services.",
    ranking: "1001-1200 (THE)",
    type: "Public",
    images: ["Images/UK/University of Wolverhampton/campus.jpg"],
    programs: ["Nursing", "Education", "Engineering", "Cyber Security"],
    features: ["Affordable Living Costs", "Strong Graduate Employment", "Modern Facilities", "Industry-focused Curriculum"]
  },
  {
    name: "University of East London",
    location: "London, England, UK",
    tuition: 14160,
    livingCost: 15000,
    description: "Career-oriented university with modern campuses in Stratford and Docklands.",
    ranking: "801-1000 (THE)",
    type: "Public",
    images: ["Images/UK/University of East London/campus.jpg"],
    programs: ["Psychology", "Sports Science", "Civil Engineering", "Data Science"],
    features: ["London Location", "Employability Focus", "Modern Accommodation", "Diverse Community"]
  },
  {
    name: "Middlesex University London",
    location: "London, England, UK",
    tuition: 14800,
    livingCost: 14500,
    description: "Global university with strong international links and innovative teaching approaches.",
    ranking: "601-800 (THE)",
    type: "Public",
    images: ["Images/UK/Middlesex University London/campus.jpg"],
    programs: ["Computer Science", "Business", "Nursing", "Design"],
    features: ["Global Network", "Work Placement Opportunities", "Modern Campus", "Entrepreneurship Support"]
  },
  {
    name: "University of Greenwich",
    location: "London, England, UK",
    tuition: 15000,
    livingCost: 14000,
    description: "Historic university with iconic campuses and strong maritime heritage.",
    ranking: "601-800 (THE)",
    type: "Public",
    images: ["Images/UK/University of Greenwich/campus.jpg"],
    programs: ["Maritime Studies", "Architecture", "Business", "Environmental Science"],
    features: ["UNESCO World Heritage Site Campus", "Strong Industry Links", "Historic Setting", "Research-led Teaching"]
  },
  {
    name: "Kingston University London",
    location: "Kingston upon Thames, London, UK",
    tuition: 15800,
    livingCost: 13500,
    description: "Creative university with excellent art and design programs, located in a riverside setting.",
    ranking: "601-800 (THE)",
    type: "Public",
    images: ["Images/UK/Kingston University London/campus.jpg"],
    programs: ["Fashion Design", "Aerospace Engineering", "Pharmacy", "Journalism"],
    features: ["Creative Hub", "Industry-standard Facilities", "Strong Graduate Outcomes", "Riverside Campus"]
  },
  {
    name: "Coventry University",
    location: "Coventry, West Midlands, UK",
    tuition: 16850,
    livingCost: 12000,
    description: "Modern university with strong emphasis on employability and industry-relevant courses.",
    ranking: "601-650 (QS)",
    type: "Public",
    images: ["Images/UK/Coventry University/campus.jpg"],
    programs: ["Automotive Engineering", "Healthcare Management", "Digital Media", "International Business"],
    features: ["Modern Campus", "Industry Partnerships", "Employability Focus", "Student Enterprise Support"]
  },
  {
    name: "University of Hertfordshire",
    location: "Hatfield, Hertfordshire, UK",
    tuition: 14750,
    livingCost: 11000,
    description: "Innovative university with strong STEM programs and excellent industry connections.",
    ranking: "801-1000 (THE)",
    type: "Public",
    images: ["Images/UK/University of Hertfordshire/campus.jpg"],
    programs: ["Aerospace Engineering", "Computer Science", "Pharmacy", "Film Production"],
    features: ["STEM Focus", "Industry Placements", "Modern Facilities", "Entrepreneurship Programs"]
  },
  {
    name: "University of Bedfordshire",
    location: "Bedford and Luton, England, UK",
    tuition: 14000,
    livingCost: 11000,
    description: "Modern university with strong health and computer science programs, offering excellent student support.",
    ranking: "1001-1200 (THE)",
    type: "Public",
    images: ["Images/UK/University of Bedfordshire/campus.jpg"],
    programs: ["Nursing", "Computer Science", "Psychology", "Business"],
    features: ["Affordable Fees", "Modern Facilities", "Industry Placements", "Student Support Services"]
  },
  {
    name: "University of Roehampton",
    location: "London, England, UK",
    tuition: 14500,
    livingCost: 13000,
    description: "Campus university in London known for its strong humanities and life sciences programs.",
    ranking: "801-1000 (THE)",
    type: "Public",
    images: ["Images/UK/University of Roehampton/campus.jpg"],
    programs: ["Dance", "Biological Sciences", "Business", "Education"],
    features: ["Green Campus", "Teaching Excellence", "Research-led Curriculum", "London Location"]
  },
  {
    name: "University of West London",
    location: "London, England, UK",
    tuition: 15000,
    livingCost: 14000,
    description: "Career-focused university particularly strong in music and hospitality management.",
    ranking: "801-1000 (THE)",
    type: "Public",
    images: ["Images/UK/University of West London/campus.jpg"],
    programs: ["Music Production", "Hospitality Management", "Law", "Nursing"],
    features: ["Industry Connections", "Modern Facilities", "London Location", "Employment-focused"]
  },
  {
    name: "University of Northampton",
    location: "Northampton, England, UK",
    tuition: 14250,
    livingCost: 9500,
    description: "Innovative university with strong emphasis on social enterprise and environmental sustainability.",
    ranking: "1001-1200 (THE)",
    type: "Public",
    images: ["Images/UK/University of Northampton/campus.jpg"],
    programs: ["Environmental Science", "Leather Technology", "Education", "Business"],
    features: ["New Waterside Campus", "Sustainability Focus", "Enterprise Culture", "Student Support"]
  },
  {
    name: "University of Portsmouth",
    location: "Portsmouth, England, UK",
    tuition: 16250,
    livingCost: 11000,
    description: "Coastal university with strong maritime and engineering programs.",
    ranking: "501-600 (THE)",
    type: "Public",
    images: ["Images/UK/University of Portsmouth/campus.jpg"],
    programs: ["Maritime Studies", "Criminal Justice", "Engineering", "Creative Technologies"],
    features: ["Coastal Location", "Industry Partnerships", "Modern Facilities", "Research Excellence"]
  },
  {
    name: "University of Sunderland",
    location: "Sunderland, England, UK",
    tuition: 13500,
    livingCost: 9000,
    description: "Career-focused university with strong media and health sciences programs.",
    ranking: "1001-1200 (THE)",
    type: "Public",
    images: ["Images/UK/University of Sunderland/campus.jpg"],
    programs: ["Media Production", "Pharmacy", "Nursing", "Engineering"],
    features: ["Affordable Living", "Industry-standard Facilities", "Work Placements", "Student Support"]
  },
  {
    name: "University of Bolton",
    location: "Bolton, England, UK",
    tuition: 12750,
    livingCost: 8500,
    description: "Compact university offering vocational programs with strong industry links.",
    ranking: "1201-1500 (THE)",
    type: "Public",
    images: ["Images/UK/University of Bolton/campus.jpg"],
    programs: ["Education", "Health Sciences", "Engineering", "Creative Writing"],
    features: ["Small Class Sizes", "Industry-focused", "Affordable Fees", "Personalized Support"]
  },
  {
    name: "University of Central Lancashire (UCLan)",
    location: "Preston, England, UK",
    tuition: 14500,
    livingCost: 9500,
    description: "Large university with strong forensic science and aerospace programs.",
    ranking: "801-1000 (THE)",
    type: "Public",
    images: ["Images/UK/University of Central Lancashire (UCLan)/campus.jpg"],
    programs: ["Forensic Science", "Aerospace Engineering", "Dentistry", "Journalism"],
    features: ["Industry Placements", "Modern Facilities", "Research-led Teaching", "Student Enterprise"]
  },
  {
    name: "University of Derby",
    location: "Derby, England, UK",
    tuition: 14900,
    livingCost: 10000,
    description: "Innovative university with strong engineering and creative arts programs.",
    ranking: "1001-1200 (THE)",
    type: "Public",
    images: ["Images/UK/University of Derby/campus.jpg"],
    programs: ["Mechanical Engineering", "Fashion Design", "Criminology", "Business"],
    features: ["Industry-standard Facilities", "Employability Focus", "Modern Campus", "Student Support"]
  },
  {
    name: "University of Huddersfield",
    location: "Huddersfield, England, UK",
    tuition: 16000,
    livingCost: 10500,
    description: "University known for music and engineering programs with excellent graduate outcomes.",
    ranking: "601-800 (THE)",
    type: "Public",
    images: ["Images/UK/University of Huddersfield/campus.jpg"],
    programs: ["Music Technology", "Mechanical Engineering", "Pharmacy", "Education"],
    features: ["Teaching Excellence", "Industry Links", "Modern Facilities", "Student Satisfaction"]
  },
  {
    name: "University of Salford",
    location: "Salford, England, UK",
    tuition: 15750,
    livingCost: 11000,
    description: "Industry-connected university near Manchester with strong media and construction programs.",
    ranking: "801-1000 (THE)",
    type: "Public",
    images: ["Images/UK/University of Salford/campus.jpg"],
    programs: ["Media Technology", "Construction Management", "Nursing", "Aeronautics"],
    features: ["Industry Partnerships", "Modern Campus", "Manchester Location", "Practical Learning"]
  },
  {
    name: "University of Brighton",
    location: "Brighton, England, UK",
    tuition: 15300,
    livingCost: 12500,
    description: "Coastal university with strengths in arts and health sciences.",
    ranking: "801-1000 (THE)",
    type: "Public",
    images: ["Images/UK/University of Brighton/campus.jpg"],
    programs: ["Pharmacy", "Architecture", "Digital Media", "Education"],
    features: ["Seaside Location", "Creative Community", "Industry Placements", "Research-informed Teaching"]
  },
  {
    name: "University of Lincoln",
    location: "Lincoln, England, UK",
    tuition: 15950,
    livingCost: 10500,
    description: "Modern university with strong agriculture and journalism programs.",
    ranking: "601-800 (THE)",
    type: "Public",
    images: ["Images/UK/University of Lincoln/campus.jpg"],
    programs: ["Agriculture", "Journalism", "Computer Science", "Business"],
    features: ["Modern Campus", "Industry-focused", "Student Satisfaction", "Research Excellence"]
  },
  {
    name: "University of Gloucestershire",
    location: "Cheltenham and Gloucester, England, UK",
    tuition: 15000,
    livingCost: 11000,
    description: "University with beautiful campuses and strengths in environmental and sports sciences.",
    ranking: "1001-1200 (THE)",
    type: "Public",
    images: ["Images/UK/University of Gloucestershire/campus.jpg"],
    programs: ["Environmental Science", "Sports Coaching", "Cyber Security", "Film Production"],
    features: ["Beautiful Campus", "Sustainability Focus", "Industry Connections", "Student Support"]
  },
].map(uni => ({
  ...uni,
  tuition: uni.tuition || 17000, // Set default tuition
  livingCost: Math.min(uni.livingCost || 15000, 20000),
  images: uni.images || ["https://images.unsplash.com/photo-1541339907198-e08756dedf3f?auto=format&fit=crop&q=80"],
  type: uni.type || "Public",
  features: uni.features || ["International Focus", "Quality Education", "Student Support", "Research Excellence"]
}));